<script lang="ts">
  let { user, count }: { user: UserType; count: number } = $props()
</script>

{#if user}
  <li class="py-4 px-4">
    <div class="flex items-center space-x-3">
      <div class="flex-shrink-0">
        <img
          src={user.avatar_thumb_url}
          class="h-8 w-8 rounded-full"
          alt={user.name}
        />
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-sm text-gray-900 truncate">
          {user.name}
        </p>
      </div>
      <div>
        <p class="text-sm font-bold text-gray-900 truncate">
          {count}
        </p>
      </div>
    </div>
  </li>
{/if}
